
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';
import { AnalysisRequest } from '@/modules/analysis/models/analysisRequest';
import AnalysisDashboardListItem from '@/modules/analysis/components/AnalysisDashboardListItem.vue';

interface ResearchFilter {
  offsetBefore: { display: boolean; value: string };
  requestStatus: undefined | string;
}

@Component({
  components: { AnalysisDashboardListItem }
})
export default class AnalysisDashboard extends Vue {
  protected readonly BUTTONS_TIMEOUT = 400;
  @State((state) => state.analysis.analysisRequestsList)
  protected analysisRequestsList!: Array<AnalysisRequest>;
  @Mutation('analysis/setAnalysisRequestsList')
  protected setAnalysisRequestsList!: (analysisRequestsList: Array<AnalysisRequest>) => Promise<void>;
  @Action('analysis/initializeAnalyzes')
  protected initializeAnalyzes!: (params?: {
    status?: string | undefined;
    offset?: string | undefined;
  }) => Promise<void>;
  @Action('analysis/moreAnalyzes')
  protected moreAnalyzes!: (params?: { status?: string | undefined; offset?: string | undefined }) => Promise<boolean>;
  protected isLoadingRefresh = false;
  protected isLoadingMore = false;
  protected isMoreAnalysis = true;
  protected filter: ResearchFilter = {
    offsetBefore: {
      display: false,
      value: new Date().toISOString().substr(0, 10)
    },
    requestStatus: RequestStatusEnum.ALL
  };

  protected mounted(): void {
    this.initializeAnalyzes();
  }

  protected refresh(): void {
    this.isLoadingRefresh = true;
    const status: undefined | string = this.currentStatusFilter;
    const dateOffset = new Date(this.filter.offsetBefore.value);
    dateOffset.setDate(dateOffset.getDate() + 1);
    const offset = dateOffset.toISOString();

    setTimeout(
      () =>
        this.initializeAnalyzes({ status, offset }).then(() => {
          this.isLoadingRefresh = false;
          this.isMoreAnalysis = true;
        }),
      this.BUTTONS_TIMEOUT
    );
  }

  protected async more(): Promise<void> {
    const status: undefined | string = this.currentStatusFilter;
    const lastOffset = this.analysisRequestsList[this.analysisRequestsList.length - 1].createdAt;

    if (lastOffset !== undefined) {
      const offset = lastOffset.toString();
      this.isLoadingMore = true;
      setTimeout(
        () =>
          this.moreAnalyzes({ status, offset }).then((res) => {
            this.isMoreAnalysis = res;
            this.isLoadingMore = false;
          }),
        this.BUTTONS_TIMEOUT
      );
    }
  }

  /**
   * The user has archive a request : the request is hidden
   */
  protected removeRequestFromList(requestId: string): void {
    const newAlysisRequestsList = this.analysisRequestsList.filter((item) => item.id !== requestId);
    this.setAnalysisRequestsList(newAlysisRequestsList);
  }

  protected get requestStatusOptions(): { text: string; value: string }[] {
    const options: { text: string; value: string }[] = [];
    for (const enumKey in RequestStatusEnum) {
      const value = (RequestStatusEnum as Record<string, string>)[enumKey];
      options.push({
        text: this.$i18n.t(`common.genericStatuses.${value}`).toString(),
        value
      });
    }

    return options;
  }

  protected get currentStatusFilter(): string | undefined {
    let status: undefined | string = undefined;
    if (this.filter.requestStatus && this.filter.requestStatus !== RequestStatusEnum.ALL) {
      // Search all means no filter
      status = this.filter.requestStatus;
    }
    return status;
  }
}
